import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'legrandav-disabledbutton-primary',
  styleUrl: 'legrandav-disabledbutton-primary.css',
  shadow: true,
})
export class LegrandavDisabledbuttonPrimary {
  @Prop() buttonText: string;

  render() {
    return (
      <Host>
        <button disabled>{this.buttonText}</button>
      </Host>
    );
  }
}
